// this file: NetworkUsageToast.jsx
import React from 'react'
import styles from './NetworkUsageToast.module.scss'

export default function NetworkUsageToast({ text }) {
  if (!text) return null
  return (
    <div className={`${styles.root}  ${styles.autoplay}`}>
      {text}
    </div>
  )
}
